import { render, staticRenderFns } from "./MassDestroyMonthlyFeeComponent.vue?vue&type=template&id=18bc15ea&"
import script from "./MassDestroyMonthlyFeeComponent.vue?vue&type=script&lang=js&"
export * from "./MassDestroyMonthlyFeeComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports